import { CLIENT_LOCATION_ENDPOINT } from '@yme/common/endpoints';
import { Network } from '@yme/services/network';
const LOCAL_STORAGE_KEY = 'clientLocationCache';
const CLIENT_LOCATION_CACHE_TIMEOUT = 3600000;
const LOCATION_CACHE = {
    value: '',
};
export function cachedClientLocationCountry() {
    const cachedData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
    const now = Date.now();
    if (cachedData?.value &&
        cachedData?.timestamp &&
        now - cachedData.timestamp < CLIENT_LOCATION_CACHE_TIMEOUT) {
        return cachedData.value;
    }
    return '';
}
export function getClientLocationCountry() {
    const cachedCountry = cachedClientLocationCountry();
    if (cachedCountry) {
        LOCATION_CACHE.value = cachedCountry;
        return Promise.resolve(cachedCountry);
    }
    // do not allow multiple requests to be sent if there is already one active
    if (LOCATION_CACHE.activePromise) {
        return LOCATION_CACHE.activePromise;
    }
    LOCATION_CACHE.activePromise = Network.get(CLIENT_LOCATION_ENDPOINT)
        .then((response) => {
        const { clientCountryCode } = response.data;
        LOCATION_CACHE.value = clientCountryCode;
        const cacheData = {
            value: clientCountryCode,
            timestamp: Date.now(),
        };
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cacheData));
        return clientCountryCode;
    })
        .catch(() => {
        return '';
    })
        .finally(() => {
        LOCATION_CACHE.activePromise = undefined;
    });
    return LOCATION_CACHE.activePromise;
}
